import React from 'react';

function CardEdu(props) {
    return (
        <div className={`card-info ${props.extraClass}`}>
            <div className="card-info__wrap">
                <div className="title">
                    <h6>
                        {props.programme_title}
                        <span className='clz-name'>{props.college_name}</span>
                        <span className='per'>{props.percentage}</span>
                    </h6>
                    <span className='year'>{props.duration  }</span>
                </div>
            </div>
        </div>
    );
}

export default CardEdu;